import React from 'react'

const FullNameOccupation = (props) => {
    const { setNameAndOccupation, fullName, occupation } = props;

    const onTextChange = (e) => {
        setNameAndOccupation({ name: e.target.name, value: e.target.value });
    };
    
    return (
        <div className="container mt-4">
            <div className="row mb-3">
                <div className="col-md-2">
                    <label htmlFor="fullname" className="form-label">Your full name: </label>
                </div>
                <div className="col-md-10">
                    <input
                        type="text"
                        id="fullname"
                        name="fullname"
                        className="form-control"
                        value={fullName}
                        onChange={onTextChange}
                        required
                        maxLength={40}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    <label htmlFor="occupation" className="form-label">Occupation: </label>
                </div>
                <div className="col-md-10">
                    <input
                        type="text"
                        id="occupation"
                        name="occupation"
                        className="form-control"
                        value={occupation}
                        onChange={onTextChange}
                        maxLength={40}
                        required
                    />
                </div>
            </div>
        </div>
    );
};

export default FullNameOccupation;